export default __webpack_public_path__ + "static/media/stop.8520dd24.svg";